import React from 'react';
import { FiClock } from 'react-icons/fi';
import Modal from '../common/Modal';

interface InactivityModalProps {
  isOpen: boolean;
  secondsLeft: number;
  onStay: () => void;
  onLogout: () => void;
}

const InactivityModal: React.FC<InactivityModalProps> = ({
  isOpen,
  secondsLeft,
  onStay,
  onLogout,
}) => (
  <Modal
    isOpen={isOpen}
    // Cualquier interacción explícita (botón, X, Escape, backdrop) cuenta como
    // "sigo aquí". El movimiento incidental del mouse no reinicia el contador.
    onClose={onStay}
    title="¿Seguís ahí?"
    titleIcon={<FiClock className="w-5 h-5 text-warning-500" />}
    size="sm"
    footer={(
      <>
        <button onClick={onLogout} className="btn-secondary">
          Cerrar sesión
        </button>
        <button onClick={onStay} className="btn-primary">
          Sigo aquí
        </button>
      </>
    )}
  >
    <div className="px-6 py-5">
      <p className="text-sm text-content-secondary">
        Tu sesión se cerrará por inactividad en{' '}
        <span className="font-semibold text-content-primary tabular-nums">{secondsLeft}s</span>.
        Hacé clic en <span className="font-medium">«Sigo aquí»</span> para seguir trabajando.
      </p>
    </div>
  </Modal>
);

export default InactivityModal;
